import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Loading from "./components/Loading";

import "../css/style.css";

const Step10_Shipping = () => {
    const [user, setUser] = useState({
        firstname: "",
        lastname: "",
        company: "",
        function: "",
        street: "",
        place: "",
        city: "",
        country: "176",
        phone: "",
        mobile: "",
        email: "",
        exhibitor: "Aussteller: false",
        logoPresence: "Ausstellerfläche / Logopräsenz: false",
        investment: "Investieren: false",
        cityTour: "Privaten Kunsthaus Führung: false",
        swissVRAwards: "",
        usesThirdPartyFinancialProducts: "",
        responsibleForDrittprodukteSelektion: "",
        activeContributionDrittprodukte: "",
        agreement: false,
        cancelationTerms: false,
        isCustomCheckboxChecked: false,
        optionsYesOrNoAnswers: {} // Store answers for OptionsYesOrNo
    });

    const theEvent = JSON.parse(sessionStorage.getItem("SwissFinanceWeekEvent"));
    const remarks = JSON.parse(theEvent.remarks);
    const [orderId] = useState(sessionStorage.getItem("OrderId"));

    const [loading, setLoading] = useState(true);
    const [errors, setErrors] = useState(""); //Todo how can i handle these errors
    const [validationError, setValidationError] = useState("");
    const [countries, setCountries] = useState([]);
    const [resources, setResources] = useState({});
    const [token] = useState(sessionStorage.getItem("token"));

    // fetching resources
    const { language } = useParams();

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    useEffect(() => {
        axios.defaults.headers.common["Authorization"] = "Bearer " + token;

        requestResources();
        requestCountries();

    }, [language]);

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data.translation);
            })
            .catch((error) => console.log(error.response.data));
    };

    const requestCountries = () => {
        setLoading(true);

        axios
            .get(`${baseUrl}/Countries?languageCode=${language}`)
            .then((res) => {
                let countries = res.data;

                //first add switzerland, germany and austria
                const indexCH = countries.findIndex((c) => c.id === 176);
                const ch = countries[indexCH];
                countries.splice(indexCH, 1);

                var indexDE = res.data.findIndex((c) => c.id === 229);
                const de = countries[indexDE];
                countries.splice(indexDE, 1);

                var indexAU = res.data.findIndex((c) => c.id === 228);
                const au = countries[indexAU];
                countries.splice(indexAU, 1);

                countries.unshift({ id: "", name: "---------" });
                countries.unshift(au);
                countries.unshift(de);
                countries.unshift(ch);

                setCountries(res.data);
            })
            .catch((error) => {
                console.error(error.response.data);
                navigate(`/${language}/sessiontimeout`);
            });

        setTimeout(() => setLoading(false), 500);
    };

    const onOptionsChange = (e) => {

        if (e.target.value.includes("Ausstellerfläche / Logopräsenz") || e.target.value.includes("logo presence")) {
            setUser({ ...user, ["logoPresence"]: "Ausstellerfläche / Logopräsenz: " + e.target.checked });
        }

        if (e.target.value.includes("Investieren") || e.target.value.includes("Invest in your knowledge")) {
            setUser({ ...user, ["investment"]: "Investieren: " + e.target.checked });
        }

        if (e.target.value.includes("Aussteller ")) {
            setUser({ ...user, ["exhibitor"]: "Aussteller: " + e.target.checked });
        }

        if (e.target.value.includes("Privaten Kunsthaus Führung")) {
            setUser({ ...user, ["cityTour"]: "Privaten Kunsthaus Führung: " + e.target.checked });
        }

        if (e.target.value.includes("agreement")) {
            setUser({ ...user, ["agreement"]: e.target.checked });
        }

        if (e.target.value.includes("cancelationTerms")) {
            setUser({ ...user, ["cancelationTerms"]: e.target.checked });
        }

        if (e.target.value.includes("Swiss VR-Awards")) {
            setUser({ ...user, ["swissVRAwards"]: "Teilnahme an den Swiss VR-Awards: " + e.target.checked });
        }
    }

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    const onRadioYesOrNoChange = (option, value) => {
        // Prepare formatted string
        const formatted = `${option}: ${value}`;
        // Prepare new user object
        let newUser = {
            ...user,
            optionsYesOrNoAnswers: {
                ...user.optionsYesOrNoAnswers,
                [option]: value
            }
        };
        // Set corresponding user property if question matches
        if (option.includes("Teil Ihres Business-Modells")) {
            newUser.usesThirdPartyFinancialProducts = formatted;
        }
        if (option.includes("verantwortlich für die Selektion dieser Drittprodukte")) {
            newUser.responsibleForDrittprodukteSelektion = formatted;
        }
        if (option.includes("Auswahl dieser Drittprodukte aktiv bei")) {
            newUser.activeContributionDrittprodukte = formatted;
        }
        if (option.includes("Möchten Sie an der Award Night teilnehmen")) {
            newUser.awardNightParticipation = formatted;
        }
        setUser(newUser);
    };

    const mapCheckboxOptions = () => {

        if (remarks == null) return null;

        let options = remarks["Options"];

        return (
            options.map(
                (opt, index) => (
                    <div key={index} className="row mt-4">
                        <div className="col-md-12">
                            <div class="form-check">
                                <input className="form-check-input" id={"chkOption" + index} type="checkbox" value={opt} onChange={(e) => onOptionsChange(e)} />
                                <label className="form-check-label" htmlFor={"chkOption" + index}>{opt}</label>
                            </div>
                        </div>
                    </div>
                )
            )
        );
    }

    const mapRadioOptionsYesOrNo = () => {

        if (remarks == null) return null;

        const options = remarks["OptionsYesOrNo"];

        if (!options || !Array.isArray(options)) return null;

        return options.map((opt, index) => (
            <React.Fragment key={index}>
                <div className="row mt-4">
                    <div className="col-md-12">
                        <label className="form-label mb-2">{opt}</label>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-md-12">
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={`radioOptionYesOrNo_${index}`}
                                id={`radioOptionYes_${index}`}
                                value="Ja"
                                checked={user.optionsYesOrNoAnswers[opt] === "Ja"}
                                onChange={() => onRadioYesOrNoChange(opt, "Ja")}
                                required
                            />
                            <label className="form-check-label" htmlFor={`radioOptionYes_${index}`}>Ja</label>
                        </div>
                        <div className="form-check form-check-inline">
                            <input
                                className="form-check-input"
                                type="radio"
                                name={`radioOptionYesOrNo_${index}`}
                                id={`radioOptionNo_${index}`}
                                value="Nein"
                                checked={user.optionsYesOrNoAnswers[opt] === "Nein"}
                                onChange={() => onRadioYesOrNoChange(opt, "Nein")}
                                required
                            />
                            <label className="form-check-label" htmlFor={`radioOptionNo_${index}`}>Nein</label>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        ));
    }

    // validating input fields
    let validation =
        user.firstname && user.firstname.trim() && /^.{1,70}$/.test(user.firstname.trim()) &&
        user.lastname && user.lastname.trim() && /^.{1,70}$/.test(user.lastname.trim()) &&
        user.function && user.function.trim() && /^.{1,70}$/.test(user.function.trim()) &&
        user.company && user.company.trim() && /^.{1,70}$/.test(user.company.trim()) &&
        user.street && user.street.trim() && /^.{1,70}$/.test(user.street.trim()) &&
        user.place && user.place.trim() && /^.{1,70}$/.test(user.place.trim()) &&
        user.city && user.city.trim() && /^.{1,70}$/.test(user.city.trim()) &&
        user.country && user.country !== "" &&
        user.email && user.email.trim() && /^\S+@\S+\.\S+$/.test(user.email.trim());

    if (validation && remarks && (remarks["HasAgreement"])) {
        validation = user.agreement;
    }

    if (validation && remarks && (remarks["HasCancelationTerms"])) {
        validation = user.cancelationTerms;
    }

    // Add mandatory validation for OptionsYesOrNo
    if (remarks && remarks["OptionsYesOrNo"] && Array.isArray(remarks["OptionsYesOrNo"])) {
        validation = validation && remarks["OptionsYesOrNo"].every(opt => user.optionsYesOrNoAnswers[opt] === "Ja" || user.optionsYesOrNoAnswers[opt] === "Nein");
    }

    // Retrieve existing addressBody from localStorage
    let existingAddressBody = {};
    try {
        existingAddressBody = JSON.parse(localStorage.getItem("addressBodySwissFitechWeek")) || {};
    } catch (e) {
        existingAddressBody = {};
    }

    const addAddressToBasket = () => {
        // Check validation first
        if (!validation) {
            setValidationError("Please fill in all required fields.");
            return;
        }

        // Clear validation error if validation passes
        setValidationError("");

        // Trim all string values before submitting
        let addressBody = {
            firstname: user.firstname?.trim() || "",
            name: user.lastname?.trim() || "",
            company: user.company?.trim() || "",
            street: user.street?.trim() || "",
            function: user.function?.trim() || "",
            postCode: user.place?.trim() || "",
            city: user.city?.trim() || "",
            telephone: user.phone?.trim() || "",
            mobile: user.mobile?.trim() || "",
            countryId: user.country,
            email: user.email?.trim() || "",
            code1: existingAddressBody?.code1
        };

        axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then((res) => {
                localStorage.setItem("addressBodySwissFitechWeek", JSON.stringify(addressBody));
                //navigate(`/${language}/interests`);
                navigate(`/${language}/participants`);
            })
            .catch((error) => {
                setErrors(error.response.data);
            });
    };

    return (
        <div>
            {loading ? (
                <>
                    <div className="d-none d-lg-block">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="50%"
                            left="50%"
                        />
                    </div>
                    <div className="d-lg-none">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="45%"
                            left="45%"
                        />
                    </div>
                </>
            ) : (
                <>
                    <Header />

                    {resources && (
                        <div className="container pt-0 wrapper-smaller">

                            <div className="row mt-5">
                                <div className="col-md-12">
                                    <span className="title">PURCHASER</span><br />
                                    <span className="text-muted">Please fill out all mandatory fields</span>
                                </div>
                            </div>

                            {/* user data */}
                            <div className="row mt-1">
                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingFirstName} *</span>
                                    <input
                                        type="text"
                                        name="firstname"
                                        className="form-control custom-textbox"
                                        value={user.firstname}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingLastName} *</span>
                                    <input
                                        type="text"
                                        name="lastname"
                                        className="form-control custom-textbox"
                                        value={user.lastname}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingCompany} *</span>
                                    <input
                                        type="text"
                                        name="company"
                                        className="form-control custom-textbox"
                                        value={user.company}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingFunction} *</span>
                                    <input
                                        type="text"
                                        name="function"
                                        className="form-control custom-textbox"
                                        value={user.function}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-12 mt-3">
                                    <span>{resources.ShippingEmail} *</span>
                                    <input
                                        type="email"
                                        name="email"
                                        className="form-control custom-textbox"
                                        value={user.email}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-12 mt-3">
                                    <span>{resources.ShippingStreet} *</span>
                                    <input
                                        type="text"
                                        name="street"
                                        className="form-control custom-textbox"
                                        value={user.street}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingPlace} *</span>
                                    <input
                                        type="text"
                                        name="place"
                                        className="form-control custom-textbox"
                                        value={user.place}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingCity} *</span>
                                    <input
                                        type="text"
                                        name="city"
                                        className="form-control custom-textbox"
                                        value={user.city}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-12 mt-3">
                                    <span>{resources.ShippingCountry} *</span>
                                    <select
                                        className="form-control custom-textbox"
                                        aria-label="Land"
                                        name="country"
                                        value={user.country}
                                        onChange={(e) => onInputChange(e)}>
                                        {countries.map((c, index) => (
                                            <option value={c.id} key={index}>
                                                {c.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingPhone}</span>
                                    <input
                                        type="text"
                                        name="phone"
                                        className="form-control custom-textbox"
                                        value={user.phone}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>

                                <div className="col-md-6 mt-3">
                                    <span>{resources.ShippingMobile}</span>
                                    <input
                                        type="text"
                                        name="mobile"
                                        className="form-control custom-textbox"
                                        value={user.mobile}
                                        onChange={(e) => onInputChange(e)}
                                        required
                                    />
                                </div>
                            </div>

                            {/* checkbox options */}

                            {mapCheckboxOptions()}

                            {/* radio options Yes/No */}

                            {mapRadioOptionsYesOrNo()}

                            {/* Validation Error Message */}
                            {validationError && (
                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <div className="alert alert-danger" role="alert">
                                            <i className="bi bi-exclamation-circle-fill me-2"></i>
                                            {validationError}
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* next button */}

                            <div className="row mt-5">
                                <div className="col-md-6 text-start">
                                    <button className="btn btn-custom" onClick={() => navigate(-1)}>
                                        {resources._Back}
                                    </button>
                                </div>
                                <div className="col-md-6 text-end">
                                    <button className="btn btn-custom" onClick={addAddressToBasket}>
                                        {resources._Next}
                                    </button>
                                </div>
                            </div>

                            {/* agb - cancelation terms */}

                            <div className="container mb-5">

                                {remarks && remarks["HasAgreement"] && (
                                    <div className="float-end position-relative mt-4">
                                        <div className="col-md-12 float-end">
                                            <label htmlFor="chkAgreement" className="me-3 lblAgreement" dangerouslySetInnerHTML={{ __html: resources.ShippingAgreement.replace("{@pdfUrl}", remarks["AgreementPDF"]) }}></label>
                                            <input id="chkAgreement" type="checkbox" className="checkboxAgreement form-check-input" value="agreement" onChange={(e) => onOptionsChange(e)} />
                                        </div>
                                    </div>
                                )}

                                {remarks && remarks["HasCancelationTerms"] && (
                                    <div className="float-end position-relative mt-4">
                                        <div className="col-md-12 float-end">
                                            <label htmlFor="chkCancelationTerms" className="me-3 lblAgreement">{remarks["CancelationTermsText"]}</label>
                                            <input id="chkCancelationTerms" type="checkbox" className="checkboxAgreement form-check-input" value="cancelationTerms" onChange={(e) => onOptionsChange(e)} />
                                        </div>
                                    </div>
                                )}

                            </div>
                        </div>
                    )}
                    <div className="container wrapper">
                        <div className="col-md-12 pt-4 text-center">
                            <Footer language={language} />
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};

export default Step10_Shipping;